<template>
  <div class="ps-item box-item">
    <div class="img-wrap">
      <el-image fit="cover" class="img" :src="itemData.img"></el-image>
    </div>
    <div class="title">{{itemData.title}}</div>
    <div class="desc">{{itemData.desc}}</div>
    <div class="price-item z-flex z-flex-between">
      <div class="price"><span>￥</span>{{itemData.price}}</div>
      <el-button type="primary" size="mini" @click="toBuy(itemData)">购买</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "psItem",
  props: {
    itemData: {
      type:Object,
      default:()=>{},
    }
  },
  data() {
    return {
      
    };
  },
  mounted() {
    
  },
  methods: {
    toUrl(url){
      this.$router.push({
        path:url,
      })
    },
    toBuy(data){
      return this.$parent.$parent.$parent.$parent.clickToPay({
        platform: 'ps',
        combo_id: data.id,
        recharge_type: 10,
        price: data.price,
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.box-item{
    height: 270px;
    .title{
      height: 20px;
      -webkit-line-clamp: 1;
    }
    .desc{
      @extend %textOverflow;
    }
    .price-item{
      margin:10px 10px 0;
      .price{
        color: $colorMain;
        font-size: 25px;
        font-family: Arial, Helvetica, sans-serif;
        span{
          font-size: 14px;
        } 
      }
    }
  }
</style>
